/** Ordine display tornei nella stessa gameweek: Basic → Plus → Rare → Epic → Unique */
const RARITY_ORDER = {
  basic: 0,
  plus: 1,
  rare: 2,
  epic: 3,
  unique: 4,
  legend: 5,
  divinity: 6,
};

function raritySortIndex(rarityRestriction) {
  if (rarityRestriction == null || String(rarityRestriction).trim() === '') {
    return RARITY_ORDER.basic;
  }
  const key = String(rarityRestriction).toLowerCase().trim();
  return RARITY_ORDER[key] ?? 50;
}

/**
 * @param {Array<{ id?: number, rarity_restriction?: string | null }>} tournaments
 * @returns {Array<typeof tournaments[0]>}
 */
export function sortGameweekTournamentsByRarity(tournaments) {
  if (!Array.isArray(tournaments) || tournaments.length === 0) {
    return Array.isArray(tournaments) ? [...tournaments] : [];
  }
  return [...tournaments].sort((a, b) => {
    const da = raritySortIndex(a?.rarity_restriction);
    const db = raritySortIndex(b?.rarity_restriction);
    if (da !== db) return da - db;
    return (Number(a?.id) || 0) - (Number(b?.id) || 0);
  });
}
